
export const cores = {
    cor1:'#C94F1E',
    cor2:'#BFBFBF',
    cor3:'#F2913D',
    cor4:'#F2CA80',
    cor5:'#f2d1c2',
}
export const meses_ano = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']

export const imagens = {
    // logo: require('../Assets/Images/VULPES_MENU_128.png'),
    logo_login: require('../Assets/Images/VULPES_SIMBOLO_V1_512.png'),
    loader_gif: require('../Assets/Images/VULPES_Loading_LOOP_300px.gif'),
    IB_exemplo: require('../Assets/IB_exemplo.png'),
    IE_exemplo: require('../Assets/IE_exemplo.png'),
    // logotipo_sem_letras: require('../Assets/Images/VULPES_SIMBOLO_V1_48.png')
    
}

export const versao = {
    versao: 'V.3.7 25-06-2026',
}

export const operacao_sucesso = 'A sua operação foi realizada com sucesso.'
export const operacao_erro = 'Erro ao realizar a sua operação.'



export const message_apenas_numero = ("Introduza apenas números");
export const mensagem_tem_a_certeza_de_apagar_alteracoes = "Tem a certeza que quer descartar as alterações realizadas?"
export const mensagem_tem_a_certeza_sair = "Tem a certeza que quer sair?"

